import { Route, Routes } from "react-router-dom";
import StoreDepositOptionPage from "@/pages/financial/store-deposit-option";

export default function StoreDepositOptionRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StoreDepositOptionPage />} />
    </Routes>
  );
}
